import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from 'axios'

export const useMainStore = defineStore('main', () => {

  const userAvatar = computed(
    () =>
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${useMainStore().user["Email"].replace(
        /[^a-z0-9]+/gi,
        '-'
      )}`
  )

  const isFieldFocusRegistered = ref(false)

  const clients = ref([])
  const history = ref([])

  const userCache = ref(null)

  function setUserDisplay(payload) {

  }

  function fetchSampleClients() {
    axios
      .get(`data-sources/clients.json?v=3`)
      .then((result) => {
        clients.value = result?.data?.data
      })
      .catch((error) => {
        alert(error.message)
      })
  }

  function fetchSampleHistory() {
    axios
      .get(`data-sources/history.json`)
      .then((result) => {
        history.value = result?.data?.data
      })
      .catch((error) => {
        alert(error.message)
      })
  }



  function setUserAuth(payload) {
    localStorage.setItem("userAuth", JSON.stringify(payload))
    //userAuth.value = JSON.stringify(payload)
    //userAuth.value = payload
    //authenticated.value = true
  }
  function setUser(payload) {
    localStorage.setItem("user", JSON.stringify(payload))
    //user.value = JSON.stringify(payload)
    //user.value = payload
  }
  function setCustomer(payload) {
    localStorage.setItem("customer", JSON.stringify(payload))
    //customer.value = JSON.stringify(payload)
    //customer.value = payload
  }
  function setDeviceList(payload) {
    localStorage.setItem("deviceList", JSON.stringify(payload))
    //deviceList.value = JSON.stringify(payload)
    //deviceList.value = payload
  }
  const userAuth = computed( () => {
    if (localStorage.getItem("userAuth"))
      return JSON.parse(localStorage.getItem("userAuth"))
    else
      return null
  })
  const user = computed( () => {
    if (localStorage.getItem("user"))
      return JSON.parse(localStorage.getItem("user"))
    else
      return null
  })
  const customer = computed( () => {
    if (localStorage.getItem("customer"))
      return JSON.parse(localStorage.getItem("customer"))
    else
      return null
  })
  const deviceList = computed( () => {
    if (localStorage.getItem("deviceList"))
      return JSON.parse(localStorage.getItem("deviceList"))
    else
      return null
  })
  const userName = computed( () => {
    if (localStorage.getItem("user")) {
      const usr = JSON.parse(localStorage.getItem("user"))
      return usr["FirstName"] + ' ' + usr["LastName"]
    } else {
      return ''
    }
  })
  const userEmail = computed( () => {
    if (localStorage.getItem("user")) {
      const usr = JSON.parse(localStorage.getItem("user"))
      return usr["Email"]
    } else {
      return ''
    }
  })

  function logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('userAuth')
    localStorage.removeItem('customer')
    localStorage.removeItem('deviceList')
  }

  return {
    userAvatar,
    isFieldFocusRegistered,
    clients,
    history,
    setUserDisplay,
    fetchSampleClients,
    fetchSampleHistory,

    setUserAuth,
    setUser,
    setCustomer,
    setDeviceList,
    user,
    customer,
    deviceList,
    userName,
    userEmail,
    logout,
  }
})